<template>
  <div class="remoteConsultation">
    <div class="table-info">
      <div class="breadcrumb">
      <span>位置：</span>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>远程医疗</el-breadcrumb-item>
        <el-breadcrumb-item>协作查房</el-breadcrumb-item>
      </el-breadcrumb>
      </div>
      <h3>协作查房</h3>
    </div>
    <div class="table-content">
      <div class="tool-bar">
          <span>关键字：</span>
          <el-input size="small" placeholder="请输入" width="264" class="key-word" v-model="keyword"></el-input>

          <span>查房时间：</span>
          <el-date-picker
            v-model="conditionTime"
            width="264"
            type="daterange"
            size="small"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <span>状态：</span>
          <el-select v-model="status"  size="small" class="status">
              <el-option
                v-for="item in statusDatas"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
          </el-select>
          <el-button type="primary" size="small" @click="searchCooperativeInfo()" v-if="isCompleted && isShowButton('查询')">查询</el-button>
          <el-button size="small" @click="reset()" v-if="isCompleted && isShowButton('重置')">重置</el-button>
          <el-button size="small" type="primary" @click="handleOption('申请')" v-if="isCompleted && isShowButton('查房申请')">查房申请</el-button>
      </div>
      <!-- 查房申请/编辑对话框 -->
      <el-dialog :title="title" :visible.sync="dialogShow" :before-close="handleClose">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-row>
            <el-col :span="23">
              <el-form-item label="查房标题:" :label-width="formLabelWidth" prop="title">
                <el-input v-model="ruleForm.title" auto-complete="off" size="small" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item prop="applyExplain">
            <el-col class="conditionTextarea" :span="3">申请说明:</el-col>
            <el-col :span="20">
              <el-input type="textarea" v-model="ruleForm.applyExplain" rows="3" placeholder="请输入"></el-input>
            </el-col>
          </el-form-item>
          <el-row :gutter="3" v-if="isHaveTopHospital">
            <el-col :span="12">
              <el-form-item label="查房医院:" :label-width="formLabelWidth" size="small" prop="roundHospital">
                <el-select v-model="ruleForm.roundHospital" placeholder="请选择" @change="changeHospital()">
                  <el-option v-for="item in ruleForm.roundHospitals"
                  :key="item.id"
                  :label="item.hospitalName"
                  :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="查房医生:" :label-width="formLabelWidth" size="small" prop="roundDoctor">
                <el-select v-model="ruleForm.roundDoctor" placeholder="请选择">
                  <el-option v-for="item in ruleForm.roundDoctors"
                  :key="item.id"
                  :label="item.userName"
                  :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="3" v-if="!isHaveTopHospital">
            <el-col :span="12">
              <el-form-item label="查房医院:" :label-width="formLabelWidth" size="small">
                <el-select v-model="ruleForm.roundHospital" placeholder="请选择" @change="changeHospital()">
                  <el-option v-for="item in ruleForm.roundHospitals"
                  :key="item.id"
                  :label="item.hospitalName"
                  :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="查房医生:" :label-width="formLabelWidth" size="small">
                <el-select v-model="ruleForm.roundDoctor" placeholder="请选择">
                  <el-option v-for="item in ruleForm.roundDoctors"
                  :key="item.id"
                  :label="item.userName"
                  :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="查房周期:" :label-width="formLabelWidth">
                  <el-radio v-model="ruleForm.RoundsPeriod" label=1>单次</el-radio>
                  <el-radio v-model="ruleForm.RoundsPeriod" label=2>每周</el-radio>
                  <el-radio v-model="ruleForm.RoundsPeriod" label=3>每月</el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="1">
              <el-form-item label="首次时间:" :label-width="formLabelWidth" prop="date">
                <el-date-picker :picker-options="pickerOptions0" type="datetime" placeholder="选择日期" v-model="ruleForm.date" style="width: 100%;" size="small"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-row>
            <el-col :span="2" :offset="17">
              <el-button @click="clear" size="small">取 消</el-button>
            </el-col>
            <el-col :span="2" :offset="2">
              <el-button :loading="isLoading" type="primary" @click="handleSubmit('ruleForm')" size="small">确 定</el-button>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
      <!-- 表格 -->
      <el-table
        :data="cooperationRound"
        v-loading="loading"
        style="width: 100%">
        <el-table-column type="expand" align="center">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="查房申请介绍:">
                    <span>{{ props.row.applyNote }}</span>
                </el-form-item>
              </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="查房标题"
          prop="roundsTitle" align="center">
        </el-table-column>
        <el-table-column
          label="查房医院"
          prop="roundsHospital" align="center">
        </el-table-column>
        <el-table-column
          label="查房医生"
          prop="roundsDoctor" align="center">
        </el-table-column>
        <el-table-column
          label="申请医院"
          prop="applyHospital" align="center">
        </el-table-column>
        <el-table-column
          label="申请医生"
          prop="applyDoctor" align="center">
        </el-table-column>
        <el-table-column
          label="查房时间"
          align="center"
          min-width="150"
         >
          <template slot-scope="scope">
            <span>{{scope.row.nextDate | date}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="周期性"
          prop="cycle">
        </el-table-column>
        <el-table-column
          label="状态"
          width="80px" align="center">
          <template slot-scope="scope">
            <span  v-if="scope.row.status==='不同意'" :title="scope.row.reason">{{scope.row.status}}</span>
            <span v-else-if="scope.row.status==='已停止'" :title="scope.row.stopReason">{{scope.row.status}}</span>
            <span v-else>{{scope.row.status}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="申请时间"
          align="center"
          min-width="150"
        >
          <template slot-scope="scope">
            <span>{{scope.row.createdTime | date}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180px" align="center">
          <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.operation" v-if="scope.row.operation.length>0" :key="index">
                <el-button v-if="item==='编辑'" type="text primary" @click="handleOption('编辑',scope.row.id)">编辑</el-button>
                <el-button v-if="item==='安排'" type="text primary" @click="roundDialog(scope.row.id)">安排</el-button>
                <el-button v-if="item==='查房'" type="text primary" @click="start(scope.row.id,scope.row.startUrl,scope.row)">查房</el-button>
                <el-button v-if="item==='进入'" type="text primary" @click="join(scope.row.joinUrl,scope.row)">进入</el-button>
                <el-popover
                  placement="top"
                  width="172"
                  v-model="scope.row.isAbolish" v-if="item==='作废'">
                  <p><i class="el-icon-error" style="color:red;"></i>该操作不可逆,是否确认？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="scope.row.isAbolish = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="scope.row.isAbolish = false,abolish(scope.row.id)">确定</el-button>
                  </div>
                  <el-button slot="reference" type="text">作废</el-button>
                </el-popover>
                <el-button v-if="item==='停止'" type="text primary" @click="isStop(scope.row.id,scope.row.nextDate,scope.row.cycle)">停止</el-button>
              </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page.sync='PageIndex' :page-sizes='[10, 20, 50]'
                     :page-size='PageSize' layout='total, sizes, prev, pager, next, jumper' :total='total'>
      </el-pagination>
    </div>
    <!--  停止模态框 -->
    <el-dialog title="停止" :visible.sync="isFalse">
      <el-form :model="stopForm" :rules="rules" ref="stopForm">
        <el-row>
          <el-col>
            <el-form-item label="停止理由:" :label-width="formLabelWidth"  prop="reason">
              <el-input v-model="stopForm.reason" auto-complete="off" size="small" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="isDanci">
            <el-form-item label="查房周期：" :label-width="formLabelWidth">
              <el-radio-group v-model="stopForm.radio">
                <el-radio label="1">单次停止</el-radio>
                <el-radio label="2">永久性停止</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="isDanci">
            <span v-if="stopForm.radio==='1'" style="color: red;padding-left: 40px">提示：{{stopForm.nextDate | date}}的查房将会被停止，你可以进行下一次的查房</span>
            <span v-else style="color: red;padding-left: 40px">提示：将会停止所有查房</span>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-row>
          <el-col :span="2" :offset="16">
            <el-button @click="isFalse = false" size="small">取 消</el-button>
          </el-col>
          <el-col :span="2" :offset="2">
            <el-button type="primary" @click="submitStop('stopForm')" size="small">确 定</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <!-- 安排对话框 -->
    <el-dialog title="安排确认（可更改查房医生、查房周期，首次时间)" :visible.sync="roundConfirm">
      <el-form :model="roundConfirmForm" :rules="rules" ref="roundConfirmForm">
        <el-row :gutter="3">
          <el-col :span="23">
            <el-form-item label="查房标题:" :label-width="formLabelWidth">
              <el-input v-model="roundConfirmForm.title" auto-complete="off" size="small" placeholder="请输入" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-col class="conditionTextarea" :span="3">申请说明:</el-col>
          <el-col :span="20">
            <el-input type="textarea" v-model="roundConfirmForm.explain" rows="3" placeholder="请输入" disabled></el-input>
          </el-col>
        </el-form-item>
        <el-row :gutter="3">
          <el-col :span="12">
              <el-form-item label="查房医院:" :label-width="formLabelWidth" size="small">
              <el-select v-model="roundConfirmForm.roundHospital" placeholder="请选择" disabled>
                <el-option v-for="item in roundConfirmForm.roundHospitals"
                :key="item.id"
                :label="item.hospitalName"
                :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="查房医生:" :label-width="formLabelWidth" size="small">
              <el-select v-model="roundConfirmForm.roundDoctor" placeholder="请选择">
                <el-option v-for="item in roundConfirmForm.roundDoctors"
                :key="item.id"
                :label="item.userName"
                :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="查房周期:" :label-width="formLabelWidth">
                <el-radio v-model="roundConfirmForm.cycle" label=1>单次</el-radio>
                <el-radio v-model="roundConfirmForm.cycle" label=2>每周</el-radio>
                <el-radio v-model="roundConfirmForm.cycle" label=3>每月</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="11" :offset="1">
            <el-form-item label="首次时间:" :label-width="formLabelWidth">
              <el-date-picker :picker-options="pickerOptions0" type="datetime" placeholder="选择日期" v-model="roundConfirmForm.date" style="width: 100%;" size="small"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="是否同意:" :label-width="formLabelWidth">
              <el-radio v-model="roundConfirmForm.isAgree" label='1'>是</el-radio>
              <el-radio v-model="roundConfirmForm.isAgree" label='2'>否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="11" :offset="1">

            <el-form-item v-show="roundConfirmForm.isAgree==='1'" label="会议室:" :label-width="formLabelWidth" size="small">
              <el-select v-model="roundConfirmForm.roomName" placeholder="请选择">
                <el-option v-for="(item, index) in roundConfirmForm.conferenceRooms"
                :key="index"
                :label="item.hospitalName"
                :value="item.hospitalId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="roundConfirmForm.isAgree != 1">
          <el-col :span="12">
            <el-form-item  v-if="roundConfirmForm.isAgree != 1" label="拒绝原因:" :label-width="formLabelWidth" size="small">
              <template>
                <el-checkbox-group v-model="checkList" @change="changeCheckBox">
                  <el-checkbox-button label="延期"></el-checkbox-button>
                  <el-checkbox-button label="系统错误"></el-checkbox-button>
                  <el-checkbox-button label="申请错误"></el-checkbox-button>
                </el-checkbox-group>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="拒绝原因:" :label-width="formLabelWidth" size="small">
              <el-input v-model="roundConfirmForm.reason"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-row>
          <el-col :span="2" :offset="16">
            <el-button @click="roundConfirm = false" size="small">取 消</el-button>
          </el-col>
          <el-col :span="2" :offset="2">
            <el-button :loading="arrangeLoading" type="primary" @click="roundConfirmFormSubmit('roundConfirmForm')" size="small">确 定</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import isShowButton from '@/mixins'
export default {
  mixins: [isShowButton],
  data() {
    return {
      isLoading: false,   //查房按钮加载动画
      arrangeLoading: false,  //安排按钮加载动画

      isHaveTopHospital: false, //该登录医院是否有上级医院
      isCompleted: false, //是否请求完成
      btnPremissionList: [],
      menuId: this.$route.query.menuId,
      hospitalId: localStorage.getItem('HospitalID'),
      checkList: [],
      hid: '',
      cooperaId:'',
      isDanci:true,
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      hubUrl: '/api/chatHub',
      // hubUrl: 'http://wh.zkcis.com:8888/chatHub',
      connection:null,
      isFalse:false,
      // isShow:false,
      stopReason:'', //停止原因
      PageIndex:1, //当前页
      PageSize:10, //每页数量
      totalCache:0, //条数
      title: "",
      colorRed: "colorRed",
      currentIndex: "",
      stopForm:{
        roomId:'',
        radio:'1',
        reason:'',
        nextDate:''
      },
      statusDatas: [
        {name:"查房中",value:3},
        {name:"新申请",value:1},
        {name:"等待中",value:2},
        {name:"不同意",value:5},
        {name:"已结束",value:6},
        {name:"已停止",value:4},
        {name:"已作废",value:7}
      ],
      status: "",
      keyword: "",
      conditionTime: '',
      // 协作查房表格
      cooperationRound: [],
      loading: true,
      // 查房申请弹出框
      dialogShow: false,
      initForm: {
        roundHospital: "", //查房医院
        roundDoctor: "", //查房医生
        title: "",
        applyExplain: "", //申请说明
        date: "",
        // 查房医院
        roundHospitals: [],
        // 查房医生
        roundDoctors: [],
        RoundsPeriod: "1" //周期
      },
      ruleForm: {},

      // 查房确认弹出框
      roundConfirm: false,
      roundConfirmForm: {
        roundHospital: "", //查房医院
        roundDoctor: "", //查房医生
        roomName: "", //会议室
        title: "",
        explain: "", //申请说明
        date: "", //首次时间
        // 查房医院组
        roundHospitals: [],
        // 查房医生组
        roundDoctors: [{
            roundDoctor: "医生1"
          }, {
            roundDoctor: "医生2"
          }],
        //会议室
        conferenceRooms: [ ],
        reason: '',
        cycle: "1", //查房周期
        isAgree: '1',
        id:''
      },
      formLabelWidth: "90px",

      // 表单验证规则
      rules: {
        roundHospital: [{ required: true, message: "请选择查房医院", trigger: "change" }],
        roundDoctor: [{ required: true, message: "请选择查房医生", trigger: "change" }],
        title: [{ required: true, message: "请输入标题" ,trigger:"blur"},{max:20,message:'标题不能超过20个字符'}],
        applyExplain: [{ required: true, message: "请输入申请说明", trigger: "blur" },{max:200,message:'说明不能超过200个字符'}],
        invitateHospital: [
          { required: true, message: "请选择邀请医院", trigger: "change" }
        ],
        invitateDoctor: [{
          required: true, message: "请选择邀请医生", trigger: "change" }],
        record:[{
          required: true, message: "请输入会诊咨询意见书", trigger: "blur" }],
        reason:[{
        required: true, message: "请输入拒绝/停止原因", trigger: "blur" },{max:100,message:'原因不能超过100个字符'}],
        stopReason:[{
          required: true, message: "请输入停止原因", trigger: "blur" },{max:100,message:'原因不能超过100个字符'}],
        date: [{
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "blur"
          }],
        remarks: [{ required: true, message: "请填写备注", trigger: "change" },{max:200,message:'备注不能超过200个字符'}]
      }
    };
  },
  methods: {
    changeCheckBox(){
      this.checkList.length > 1 ? this.roundConfirmForm.reason = this.checkList.join(', ') : this.roundConfirmForm.reason = this.checkList.join('')
    },
    clear(){
      this.dialogShow = false;
      this.$refs['ruleForm'].resetFields();
    },
    handleClose(done){
      this.$confirm('关闭后信息不能保存,是否退出？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
      this.$refs['ruleForm'].resetFields();
    },
    handleSizeChange(val) {
      this.PageSize = val
      this.searchCooperativeInfo()
    },
    handleCurrentChange(val) {
      this.PageIndex = val
      this.searchCooperativeInfo()
    },
    // 安排初始化数据
    roundDialog(id) {  //安排
      this.roundConfirm = true
      this.roundConfirmForm.id=id
      this.getHospitalInfo()
      this.Axios.get("/api/User/GetUserInfo").then(res=>{
        if(res.data.status===100){
          this.roundConfirmForm.conferenceRooms=res.data.ret.boardroom.value
        } else {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: "error"
          });
        }
      })
      this.Axios.get("/api/Cooperative/GetCooperativeById?id="+id).then(res=>{
        const dataInfo=res.data.data
        if(res.data.status===100){
          this.roundConfirmForm.title=dataInfo.roundsTitle
          this.roundConfirmForm.explain=dataInfo.applyNote
          this.roundConfirmForm.roundHospital=dataInfo.roundsHospital
          this.roundConfirmForm.cycle=dataInfo.roundsPeriod.toString()
          this.roundConfirmForm.date=dataInfo.nextDate
        } else {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: "error"
          });
        }
        var obj={id:dataInfo.roundsHospital,hospitalName:dataInfo.hospitalName}
        this.roundConfirmForm.roundHospitals.push(obj)
        this.Axios.get('/api/Hospital/GetDoctorByHId?hospitalId=' + this.roundConfirmForm.roundHospital).then(res => {
          if(res.data.status===100){
            this.roundConfirmForm.roundDoctors=res.data.data
            this.roundConfirmForm.roundDoctor=dataInfo.roundsDoctor
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "error"
            });
          }
        }).catch(error=>{
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          });
        })
      }).catch(error=>{
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    },
    // 查房
    start(id,url,val){
      //查房进入直播间
      // 把会诊时间转为日期对象
      let dateObj = new Date(val.nextDate)
      //把会诊时间转为时间戳
      let dateStamp = Date.parse(dateObj)
      let currentDate = new Date()
      let currentStamp = Date.parse(currentDate)
      if((dateStamp - currentStamp) > 1200000) {
        this.$message({
          showClose: true,
          message: '查房前二十分钟才能开始进行查房',
          type: 'error'
        })
      }else {
        this.Axios.get(`/api/LiveCourse/GetZhuMuAgreement?ID=${id}&type=2`).then(res => {
          const data = res.data
          if (data.status === 100) {
            window.open(data.data, '_self')
            this.searchCooperativeInfo()
          } else {
            this.$message.warning(data.message)
          }
        }).catch(() => {
          this.$message.error('网络错误，请联系管理员！')
        })
        // this.Axios.get("/api/LiveCourse/RefreshStartUrl?ID="+id+"&type=3").then(res=>{
        //   if(res.data.status === 100){
        //     window.open(res.data.startUrl)
        //     this.searchCooperativeInfo()
        //   } else if(res.data.status === 200){
        //     this.$message({
        //       showClose: true,
        //       message: '内部异常联系管理员!',
        //       type: 'error'
        //     })
        //   } else {
        //     this.$message({
        //       showClose: true,
        //       message: '参数错误!',
        //       type: 'error'
        //     })
        //   }
        // })
      }
    },
    //进入直播间
    join(url,val){
      // 把会诊时间转为日期对象
      let dateObj = new Date(val.nextDate)
      //把会诊时间转为时间戳
      let dateStamp = Date.parse(dateObj)
      //获取当前时间
      let currentDate = new Date()
      let currentStamp = Date.parse(currentDate)
      if((dateStamp - currentDate) > 1200000) {
        this.$message({
          showClose: true,
          message: '查房前二十分钟才能开始进行查房',
          type: 'error'
        })
      } else {
        this.Axios.get(`/api/LiveCourse/GetZhuMuAgreement?ID=${val.id}&type=2`).then(res => {
          const data = res.data
          if (data.status === 100) {
            window.open(data.data, '_self')
            this.Axios.get(`/api/Boardroom/JoinInfos?mid=${val.id}&type=2`).then(res => {
              console.log("进入", res.data)
            })
            this.searchCooperativeInfo()
          } else {
            this.$message.warning(data.message)
          }
        }).catch(() => {
          this.$message.error('网络错误，请联系管理员！')
        })
        // this.Axios.get("/api/LiveCourse/GetJoinUrl").then(res=>{
        //   const data = res.data
        //   if (data.status === 100) {
        //     let joinUrl = url + '?zpk=' + data.data
        //     window.open(joinUrl)
        //     this.Axios.get('/api/Boardroom/JoinInfos?mid=' + val.id + '&type=2').then(res => {
        //     })
        //   } else if (data.status === 200) {
        //     this.$message({
        //       showClose: true,
        //       message: '未查询到账号信息!',
        //       type: 'error'
        //     })
        //   }
        // })
        // this.searchCooperativeInfo()
      }
    },
    submitStop(formName){
      this.$refs[formName].validate(valid => {
        if(valid) {
          if (!this.isDanci) {
            this.stopForm.radio = '2'
          }
          this.Axios.put("/api/Cooperative/CancelCooperative?id="+this.stopForm.roomId+"&cancelReason="+this.stopForm.reason+"&status="+parseInt(this.stopForm.radio)).then(res=>{
            if(res.data.status===100){
              this.$message({
                showClose: true,
                message: '停止成功',
                type: 'success'
              });
              this.searchCooperativeInfo()
            } else {
              this.$message({
                showClose: true,
                message: res.data.message,
                type: "error"
              });
            }
            this.isFalse=false
          }).catch(error=>{
            this.$message({
              showClose: true,
              message: '网络错误，联系管理员',
              type: 'error'
            });
          })
        }
      })
    },
    //停止
    isStop(id,date,iscycle) {
      this.isFalse=true
      this.stopForm.roomId = id
      this.stopForm.nextDate = date
      iscycle == '单次' ? this.isDanci = false : this.isDanci = true
    },
    // 作废
    abolish(id) {
      this.Axios.put("/api/Cooperative/DiscardCooperative?id="+id).then(res=>{
        if(res.data.status===100){
          this.$message({
            showClose: true,
            message: '作废成功',
            type: 'success'
          });
          this.searchCooperativeInfo()
        } else {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: "error"
          });
        }
      }).catch(error=>{
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    },
    reset() {
      this.keyword = "";
      this.status = "";
      this.conditionTime = ''
      this.searchCooperativeInfo()
      this.$route.query.id=''
    },
    //申请、编辑操作
    handleOption(option,id){
      this.ruleForm={}
      this.getHospitalInfo()
      if(option==='申请'){
        this.title='查房申请'
        this.dialogShow=true
        this.ruleForm=this.initForm
        this.ruleForm.roundHospital = this.hid
        this.Axios.get('/api/Hospital/GetDoctorByHId?hospitalId=' + this.hid).then(res => {
          if(res.data.status===100){
            this.ruleForm.roundDoctors = res.data.data
              this.ruleForm.roundDoctor = res.data.data[0].id
          } else {
            this.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          });
          }
        }).catch(error=>{
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          });
        })
      }else if(option==='编辑'){
        this.title='编辑申请'
        this.dialogShow=true
        this.ruleForm=this.initForm
        this.Axios.get("/api/Cooperative/GetCooperativeById?id="+id).then(res=>{
          const dataInfo=res.data.data
          // console.log(dataInfo)
          if(res.data.status===100){
            this.ruleForm.id=dataInfo.id
            this.ruleForm.title=dataInfo.roundsTitle
            this.ruleForm.applyExplain=dataInfo.applyNote
            this.ruleForm.roundHospital=dataInfo.roundsHospital
            this.changeHospital()
            this.ruleForm.roundDoctor=dataInfo.roundsDoctor
            this.ruleForm.RoundsPeriod=dataInfo.roundsPeriod.toString()
            this.ruleForm.date=new Date(dataInfo.nextDate)
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: "error"
            });
          }
        }).catch(error=>{
          this.$message({
            showClose: true,
            message: '网络错误，联系管理员',
            type: 'error'
          });
        })
      }
    },
    // 申请,编辑用户表单
    handleSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.isLoading = true
          this.dialogShow = true
          const conditions={
            RoundsTitle:this.ruleForm.title,
            ApplyNote:this.ruleForm.applyExplain,
            RoundsHospital:this.ruleForm.roundHospital,
            RoundsDoctor:this.ruleForm.roundDoctor,
            RoundsPeriod:parseInt(this.ruleForm.RoundsPeriod),
            FirstDate:this.ruleForm.date
          }
          if(this.title==='查房申请'){
            this.Axios.post("/api/Cooperative/AddCooperative",conditions).then(res=>{
              if(res.data.status===103){
                this.$message({
                  showClose: true,
                  message: res.data.message,
                  type: 'error'
                })
                this.isLoading = false
                this.dialogShow = true
              }else if(res.data.status===100){
                this.$message({
                  showClose: true,
                  message: '添加成功',
                  type: 'success'
                })
                this.isLoading = false
                this.dialogShow = false
                this.searchCooperativeInfo()
              } else if (res.data.status===102) {
                  this.$message({
                    showClose: true,
                    message: res.data.message,
                    type: 'error'
                  })
                  this.isLoading = false
                  this.dialogShow = true
              } else {
                this.$message({
                  showClose: true,
                  message: '内部异常',
                  type: 'error'
                })
                this.isLoading = false
                this.dialogShow = true
              }
              this.$refs[formName].resetFields();
              // this.dialogShow = false
            }).catch(error=>{
              this.$message({
                showClose: true,
                message: '网络错误，联系管理员',
                type: 'error'
              });
            })
          }else if(this.title==='编辑申请'){
            this.isLoading = true
            this.dialogShow = true
              this.Axios.put("/api/Cooperative/UpdateCooperativeById?id="+this.ruleForm.id,conditions).then(res=>{
                if(res.data.status===100){
                  this.$message({
                    showClose: true,
                    message: '编辑成功',
                    type: 'success'
                  });
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.message,
                    type: "error"
                  });
                }
                this.isLoading = false
                this.dialogShow = false
                this.$refs[formName].resetFields();
                // this.dialogShow=false
                this.searchCooperativeInfo()
              }).catch(error=>{
                this.$message({
                  showClose: true,
                  message: '网络错误，联系管理员',
                  type: 'error'
                });
              })
          }
        } else {
          this.dialogShow = true
          return false;
        }
      });
    },
    // 执行安排查房
    roundConfirmFormSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.arrangeLoading = true
          this.roundConfirm = true
          const conditions={
            Boardroom:this.roundConfirmForm.roomName,
            RoundsDoctor:this.roundConfirmForm.roundDoctor,
            RoundsPeriod:parseInt(this.roundConfirmForm.cycle),
            FirstDate:this.roundConfirmForm.date,
          }
          if(this.roundConfirmForm.isAgree==='1'){
            conditions.IsAgree=true
          }else{
            conditions.IsAgree=false
          }
          if(this.roundConfirmForm.isAgree==='2'){
            conditions.Reason = this.roundConfirmForm.reason
          }
          if(this.roundConfirmForm.isAgree==='1'){
            this.Axios.get('/api/User/JudgeBoardroomInfo?time='+moment(this.roundConfirmForm.date).format('YYYY-MM-DD HH:mm:ss')+'&boardroomId='+this.roundConfirmForm.roomName).then(res=>{
              if(res.data.flag&&res.data.status===100){
                this.$confirm('次会议时时间段有冲突，是否继续？','提示',{
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(()=>{
                  this.Axios.put("/api/Cooperative/ArrangeCooperative?id="+this.roundConfirmForm.id,conditions).then(res=>{
                    if(res.data.status===100){
                      this.$message({
                        showClose: true,
                        message: '安排成功',
                        type: 'success'
                      });
                      this.roundConfirm = false
                      this.searchCooperativeInfo()
                    }else{
                      this.$message({
                        showClose: true,
                        message: res.data.message,
                        type: 'error'
                      });
                      this.roundConfirm = true
                    }
                    this.arrangeLoading = false
                    this.searchCooperativeInfo()
                  }).catch(error=>{
                    this.arrangeLoading = false
                    this.$message({
                      showClose: true,
                      message: '网络错误，联系管理员',
                      type: 'error'
                    });
                  })
                }).catch(()=>{
                  this.$message({
                    type: 'info',
                    message: '已取消'
                  });
                })
              }else if(!res.data.flag&&res.data.status===100){
                this.Axios.put("/api/Cooperative/ArrangeCooperative?id="+this.roundConfirmForm.id,conditions).then(res=>{
                  if(res.data.status===100){
                    this.$message({
                      showClose: true,
                      message: '安排成功',
                      type: 'success'
                    });
                    this.roundConfirm = false
                    this.searchCooperativeInfo()
                  }else{
                    this.$message({
                      showClose: true,
                      message: res.data.message,
                      type: 'error'
                    });
                    this.roundConfirm = true
                  }
                  this.arrangeLoading = false
                }).catch(error=>{
                  this.arrangeLoading = false
                  this.$message({
                    showClose: true,
                    message: '网络错误，联系管理员',
                    type: 'error'
                  });
                })
              }else{
                this.$message({
                  showClose: true,
                  message: '内部异常，请联系管理员',
                  type: 'error'
                });
              }
            })
          }else{
            this.Axios.put("/api/Cooperative/ArrangeCooperative?id="+this.roundConfirmForm.id,conditions).then(res=>{
              if(res.data.status===100){
                this.$message({
                  showClose: true,
                  message: '安排成功',
                  type: 'success'
                });
                this.roundConfirm = false
              }else{
                this.$message({
                  showClose: true,
                  message: res.data.message,
                  type: 'error'
                });
                this.roundConfirm = true
              }
              this.arrangeLoading = false
              this.searchCooperativeInfo()
            }).catch(error=>{
              this.arrangeLoading = false
              this.$message({
                showClose: true,
                message: '网络错误，联系管理员',
                type: 'error'
              });
            })
          }

        } else {
          this.roundConfirm = true;
          return false;
        }
      });
    },
    // 获取上级医院
    getHospitalInfo(){
      this.Axios.get("/api/Hospital/GetSuperiorHospital?hospitalID=" + this.hospitalId).then(res=>{
        if(res.data.status===100){
          this.initForm.roundHospitals=res.data.data
          this.ruleForm.roundHospitals=res.data.data
          this.hid = res.data.data[0].id
          this.isHaveTopHospital = true
        } else if (res.data.status == 101) {
          this.isHaveTopHospital = false
          this.$message({
            showClose: true,
            message: '当前登录用户没有上级医院!',
            type: 'error'
          });
        }
      }).catch(error=>{
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    },
    changeHospital(){
      this.Axios.get('/api/Hospital/GetDoctorByHId?hospitalId=' + this.ruleForm.roundHospital).then(res => {
        if(res.data.status===100){
          this.ruleForm.roundDoctors=res.data.data
        } else {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          });
        }
      }).catch(error=>{
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    },
    searchCooperativeById(){
      this.loading = true
      this.Axios.get('/api/Remote/HomeJump?id='+this.cooperaId+'&type='+2).then(res=>{
        // console.log('aa',res)
        const data = res.data
        // console.log('查房', data)
        if(data.status == 100){
          this.cooperationRound = data.data.ret
          this.totalCache = data.data.total
        } else {
          this.$message({
            showClose: true,
            message: res.data.message,
            type: 'error'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        })
      })
    },
    searchCooperativeInfo(){
      const conditions={
        PageIndex:this.PageIndex,
        PageSize:this.PageSize,
      }
      if(this.status!=''){
        conditions.status=this.status
      }
      if(this.keyword!=''){
        conditions.keyword=this.keyword
      }
      if (this.conditionTime && this.conditionTime.length === 2) {
        conditions.time = `${moment(this.conditionTime[0]).format('YYYY-MM-DD HH:mm:ss')},${moment(this.conditionTime[1]).format('YYYY-MM-DD 23:59:59')}`
      }
      this.loading = true
      this.Axios.get("/api/Cooperative/SearchCooperativeInfo",{params:conditions}).then(res=>{
        if(res.data.status===100){
          this.cooperationRound = res.data.data.ret
          this.totalCache = res.data.data.total
          this.loading = false
        }else{
          this.cooperationRound = []
          this.loading = false
        }
      }).catch(error=>{
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    }
  },
  created(){
    if (this.$route.query.id == undefined || this.$route.query.id == '') {
      this.getBtnRole()
    }
    // this.connection = new signalR.HubConnectionBuilder().withUrl(this.hubUrl).build();
    // this.connection.start().catch(function (err) {
    //   return console.error(err.toString())
    // })
    // this.connection.on("RefreshCallbackForm",()=>{
    //   this.searchCooperativeInfo()
    // })
    // this.connection.onclose(()=>{
    //   this.connection.start().catch((err)=>{
    //     return console.log("链接又失败了")
    //   })
    // })

    this.getHospitalInfo()
  },
  mounted() {
    if(this.$route.query.id != undefined && this.$route.query.id != ''){
      this.cooperaId = this.$route.query.id
      this.searchCooperativeById()
    }else{
      this.searchCooperativeInfo()
    }
  },
  computed: {
    total() {
      return this.totalCache
    }
  },
  filters: {
    date(value) {
      value = moment(value).format('YYYY-MM-DD HH:mm')
      return value
    }
  }
};
</script>

<style scoped lang="less">
.remoteConsultation {
  /*.el-button {*/
    /*padding: 0px;*/
  /*}*/
  .el-table td {
    padding: 20px 0 !important ;
  }
  .el-table td div{
    display: inline
  }
  .breadcrumb {
    overflow: hidden;
    span,
    .el-breadcrumb {
      float: left;
    }
    span {
      font-size: 14px;
      color: #666;
      line-height: 1;
    }
  }
  .table-content {
    .tool-bar {
      padding: 0 20px;
      span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 400;
      }
      .key-word,
      .status {
        width: 264px;
        margin-right: 40px;
      }
    }
    .el-table {
      margin:20px 0px;
      .marginLeft10{
        margin-left: 10px;
      }
    }
    .el-pagination {
      /deep/ .number {
        background: #fff;
      }
    }
    .pageSize {
      margin-top: 25px;
    }
    .conditionTextarea {
      width: 70px;
      height: 60px;
      line-height: 24px !important;
      text-align: right;
      margin-right: 8px;
    }
    .consent {
      padding-left: 10px;
    }
    .uploadBtn {
      margin-right: 10px;
    }
    .el-icon-upload2 {
      font-size: 14px;
      margin-right: 5px;
    }
    .el-icon-download {
      font-size: 20px;
    }
    .el-dialog__wrapper {
      /deep/ .el-dialog__header {
        border-bottom: 1px solid #d9d9d9;
      }
      /deep/ .el-dialog__footer {
        border-top: 1px solid #d9d9d9;
      }

    }

  }
  .el-dialog__wrapper {
    /deep/ .el-dialog__header {
      border-bottom: 1px solid #d9d9d9;
    }
    /deep/ .el-dialog__footer {
      border-top: 1px solid #d9d9d9;
    }

    /deep/ .el-dialog__title {
      font-size: 14px;
    }

    /deep/ .el-dialog{
      width:770px;
    }
    /deep/ .el-input--suffix{
      width: 254px;
    }
    /deep/ .el-textarea__inner{
      width: 620px;
    }
    .uploadBtn {
      margin-right: 10px;
    }
    .consent {
      padding-left: 10px;
    }
    .conditionTextarea {
      width: 70px;
      height: 60px;
      line-height: 24px !important;
      text-align: right;
      margin-right: 8px;
    }
    .colorRed{
      color: red;
    }
  }
  /deep/ .el-form-item.is-required .el-form-item__label:before {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/RemoteMedical/CooperationRound.vue